import React from 'react';
import { connect } from 'react-redux';

import DeviceSelect from '../layout/DeviceSelect';
import { withRouter } from 'react-router-dom';

import { setActiveTab } from '../../actions/profileForm';
import {
  updateProfileIds
} from '../../actions/devices';

import {
  selectDevice,
  unselectDevice,
  selectDevices,
  unselectDevices,
  clearDeviceSelection,
  setTileMode,
  setHoveredDevices,
} from '../../actions/map';

function backToShow(match, history, location) {
  history.push(`/organisations/${match.params.organisationId}/profiles/${match.params.profileId}${location.search}`);
}

export default withRouter(connect(
  ({ profiles, devices, ui }, { match }) => ({
    //selectedProfile: profiles.data.find(p => p.id === match.params.profileId),
    selectedDevices: ui.map.selected_device_ids.slice(0, 20).map(sd => devices.data.find(d => d.id === sd)),
    selectedDeviceCount: ui.map.selected_device_ids.length,
    selectedDeviceIds: ui.map.selected_device_ids,
    processingSelection: ui.map.processingSelection,
    tileMode: ui.map.tile_mode,
    devices: devices.data,
    activeTab: ui.profileForm.activeTab,
    activeCondition: d => d.profile_id === match.params.profileId,
    selectableCondition: d => d.profile_id !== match.params.profileId,
  }),
  (dispatch, { match, history, location }) => ({
    onSelectDevice: (e) => dispatch(selectDevice(e.element.values_.id)),
    onDeselectDevice: (e) => dispatch(unselectDevice(e.element.values_.id)),
    onClearDeviceSelection: () => dispatch(clearDeviceSelection()),
    onSelectDevices: (device_ids) => dispatch(selectDevices(device_ids)),
    onUnselectDevices: (device_ids) => dispatch(unselectDevices(device_ids)),
    onSaveSelectedDevices: () => dispatch(updateProfileIds(match.params.organisationId, match.params.profileId)).then(() => backToShow(match, history, location)),
    onSetActiveTab: (day) => dispatch(setActiveTab(day)),
    onCancelClick: () => history.push(`/organisations/${match.params.organisationId}/profiles/${match.params.profileId}${location.search}`),
    onTileModeChange: (e) => dispatch(setTileMode(e.target.value)),
    onFeatureHover: (features) => dispatch(setHoveredDevices(features)),
  }))(DeviceSelect));



// WEBPACK FOOTER //
// ./src/components/pages/ProfileDeviceSelect.js